import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoaderPinwheel } from 'lucide-react';
import { ICON_SIZE } from '../../../constants/icons';
import { completeAdminAuthCallback } from '../../lib/adminAuthCallback';

export function AdminAuthCallbackPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing sign-in…');

  useEffect(() => {
    let cancelled = false;

    async function run() {
      const { error } = await completeAdminAuthCallback();

      if (cancelled) {
        return;
      }

      window.history.replaceState({}, '', '/admin/auth/callback');

      if (error) {
        console.error('[error] [admin:authCallback] Sign-in failed', { message: error });
        navigate(`/admin/login?error=${encodeURIComponent(error)}`, { replace: true });
        return;
      }

      navigate('/admin/articles', { replace: true });
    }

    void run().catch((err: unknown) => {
      if (cancelled) {
        return;
      }

      const errorMessage = err instanceof Error ? err.message : 'Sign-in failed';
      setMessage(errorMessage);
      navigate(`/admin/login?error=${encodeURIComponent(errorMessage)}`, { replace: true });
    });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-surface-base text-text-primary">
      <LoaderPinwheel className="animate-spin" size={ICON_SIZE.xl} />
      <p className="text-caption text-text-secondary">{message}</p>
    </div>
  );
}
